export default {
  default: {
    error: ``,
    success: ``,
  },
  getByToken: {
    404: `Sorry, we couldn't locate the requested induction`,
  },
};
